module.exports = __webpack_public_path__ + "static/img/fullscreen-image_our-awards_600.1d04135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/fullscreen-image_our-awards_600.png
// module id = qGcI
// module chunks = 0